import React from 'react';
import { Provider as BusProvider } from 'react-bus';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DjinnProvider: React.FC<{ children: any }> = ({ children }) => {
  return (
    <BusProvider>
      {children}
      <div id="confirm-delete-popup" />
      <ToastContainer />
    </BusProvider>
  );
};

export default DjinnProvider;
